import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  toString1pkumu07cwy4m as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../theming/AppColors.mjs';
import { Companion_getInstancenv8qpb0wanrh as Companion_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Paint.mjs';
import {
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
  body3i5t0n7zprpqb as body,
  centeredBody28evt7zh2q8en as centeredBody,
  smallBody2trfy14zwtona as smallBody,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
} from '../../theming/Titles.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf2zpbbmyqk8xpf as mapOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import {
  get_px8ok5q0jdway2 as get_px,
  get_dp28ag147e4p5cz as get_dp,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { Edges2jf5wl855ambv as Edges } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
import {
  ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance,
  HoverSemantic_getInstance2nvjr5vpt4xe8 as HoverSemantic_getInstance,
  Semanticpmpmvt7fldq2 as Semantic,
  HeaderSemantic_getInstance39z1p9hszg7wp as HeaderSemantic_getInstance,
  CardSemantic_getInstance24h7hf3qltxfl as CardSemantic_getInstance,
  ListSemantic_getInstance1hx6c2zatma42 as ListSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  times2ukvaf6yk96p2 as times,
  timesx4ey3un7ihw1 as times_0,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { LightSection_getInstance1p9fz392synu9 as LightSection_getInstance } from '../../theming/sections.mjs';
import {
  TextButtonSemantic_getInstance1oqfo0yth5rcj as TextButtonSemantic_getInstance,
  get_textButtonybbt8y3eu5hx as get_textButton,
} from '../../theming/buttons.mjs';
import { mapOf1xd03cq9cnmy8 as mapOf_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  forEachById3ln6mzh4mndq4 as forEachById,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_compact3lsezez8nz8b6 as get_compact,
  dynamicThemexp3sdnaolntz as dynamicTheme,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  RenderSize_Numerical_getInstance1z6x2shksihh7 as RenderSize_Numerical_getInstance,
  renderToString1atd3jbop96tk as renderToString,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.mjs';
import { DisplayableStateSemantic2q119ycceacla as DisplayableStateSemantic } from '../../theming/states.mjs';
import {
  MonetaryValue__toStringAbsolute_impl_uovmiublgrzadk0gpl as MonetaryValue__toStringAbsolute_impl_uovmiu,
  _MonetaryValue___get_absoluteValue__impl__hjldkw3vj23mkf30f7c as _MonetaryValue___get_absoluteValue__impl__hjldkw,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__times_impl_hlr6p73k8qwiemwou4p as MonetaryValue__times_impl_hlr6p7,
  MonetaryValue__compareTo_impl_w7ul1r2xnp6r3vvhd1h as MonetaryValue__compareTo_impl_w7ul1r,
  MonetaryValue__minus_impl_jw9qyp323r7b11udph7 as MonetaryValue__minus_impl_jw9qyp,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
} from '../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { infoBubblebw7xb14ivkdr as infoBubble } from '../../components/iconShortcuts.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { trackWeights2d4yjn3jzod5x as trackWeights } from '../../../utils/tables/ColumnWeights.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import {
  sortedWith2csnbbb21k0lg as sortedWith,
  withIndex37cl61h9v5txo as withIndex,
  toList3jhuyej2anx2q as toList,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { JumpTo_getInstance3ru9x2o8nieur as JumpTo_getInstance } from '../../../utils/JumpTo.mjs';
import { get_pageNavigator1inl9j7ja0vlf as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { ContractorProject2o386x7rid4t as ContractorProject } from './ContractorProject.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var ProjectContractorPaymentsClass;
function ProjectContractorPayments() {
  if (ProjectContractorPaymentsClass === VOID) {
    class $ {
      constructor(project, ledgerItems, lineItems) {
        this.xjd_1 = project;
        this.yjd_1 = ledgerItems;
        this.zjd_1 = lineItems;
      }
      toString() {
        return 'ProjectContractorPayments(project=' + toString(this.xjd_1) + ', ledgerItems=' + toString_0(this.yjd_1) + ', lineItems=' + toString_0(this.zjd_1) + ')';
      }
      hashCode() {
        var result = this.xjd_1 == null ? 0 : this.xjd_1.hashCode();
        result = imul(result, 31) + hashCode(this.yjd_1) | 0;
        result = imul(result, 31) + hashCode(this.zjd_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ProjectContractorPayments()))
          return false;
        if (!equals(this.xjd_1, other.xjd_1))
          return false;
        if (!equals(this.yjd_1, other.yjd_1))
          return false;
        if (!equals(this.zjd_1, other.zjd_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ProjectContractorPayments');
    ProjectContractorPaymentsClass = $;
  }
  return ProjectContractorPaymentsClass;
}
function FinanceTableSemantic$default$lambda($this$to, header) {
  var tmp0_font = header.eb0_1.td4(VOID, VOID, true);
  var tmp1_background = AppColors_getInstance().cfz_1.xg9_1;
  var tmp2_foreground = Companion_getInstance().raz_1;
  var tmp = SmallBodySemantic_getInstance();
  var tmp3_derivations = mapOf(to(tmp, FinanceTableSemantic$default$lambda$lambda));
  return $this$to.hd1(header, VOID, tmp0_font, VOID, VOID, VOID, VOID, tmp2_foreground, VOID, VOID, VOID, VOID, tmp1_background, VOID, VOID, VOID, VOID, VOID, tmp3_derivations);
}
function FinanceTableSemantic$default$lambda$lambda($this$to, it) {
  return $this$to.ed1(it, VOID, it.eb0_1.dd1(VOID, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().vg1_1), VOID, VOID, VOID, VOID, AppColors_getInstance().ffz_1.yg9_1);
}
function FinanceTableSemantic$default$lambda_0($this$to, it) {
  var onGrey = equals(it.ob0_1, AppColors_getInstance().ffz_1.aga_1);
  var tmp0_background = Companion_getInstance().raz_1;
  var tmp1_outline = onGrey ? null : AppColors_getInstance().ffz_1.aga_1;
  var tmp2_outlineWidth = onGrey ? null : get_px(3);
  return $this$to.hd1(it, false, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_outline, tmp2_outlineWidth, VOID, tmp0_background);
}
function FinanceTableSemantic$default$lambda_1($this$to, it) {
  var onGrey = equals(it.ob0_1, AppColors_getInstance().ffz_1.aga_1);
  var tmp0_background = AppColors_getInstance().ffz_1.aga_1;
  var tmp1_outline = onGrey ? Companion_getInstance().raz_1 : null;
  var tmp2_outlineWidth = onGrey ? get_px(3) : null;
  return $this$to.hd1(it, false, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_outline, tmp2_outlineWidth, VOID, tmp0_background);
}
function FinanceTableSemantic$default$lambda_2($this$to, it) {
  return $this$to.ed1(it, false, VOID, VOID, VOID, get_px(0));
}
function FinanceTableSemantic$default$lambda_3($this$to, it) {
  return $this$to.hd1(it, VOID, VOID, VOID, VOID, VOID, Edges().ad0(get_px(0)));
}
function FinanceTableSemantic$default$lambda_4($this$to, txtbtn) {
  var tmp = txtbtn.db1(ButtonSemantic_getInstance()).eb1_1;
  var tmp_0 = AppColors_getInstance().cfz_1.xg9_1;
  var tmp_1 = get_dp(0);
  var tmp_2 = HoverSemantic_getInstance();
  return $this$to.kd1(tmp, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, VOID, VOID, tmp_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, mapOf(to(tmp_2, FinanceTableSemantic$default$lambda$lambda_0))).bb1_1;
}
function FinanceTableSemantic$default$lambda$lambda_0($this$to, it) {
  return $this$to.ed1(it, VOID, it.eb0_1.dd1(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, true));
}
var FinanceTableSemanticClass;
function FinanceTableSemantic() {
  if (FinanceTableSemanticClass === VOID) {
    class $ extends Semantic() {
      static bje() {
        FinanceTableSemantic_instance = null;
        var $this = this.bd1('fintable');
        FinanceTableSemantic_instance = $this;
        return $this;
      }
      cd1(theme) {
        var tmp = theme.ib0_1.gd0(times(theme.ib0_1.kb2_1, 2), VOID, times_0(theme.ib0_1.mb2_1, 1.5));
        var tmp_0 = HeaderSemantic_getInstance();
        var tmp_1 = to(tmp_0, FinanceTableSemantic$default$lambda);
        var tmp_2 = CardSemantic_getInstance();
        var tmp_3 = to(tmp_2, FinanceTableSemantic$default$lambda_0);
        var tmp_4 = LightSection_getInstance();
        var tmp_5 = to(tmp_4, FinanceTableSemantic$default$lambda_1);
        var tmp_6 = ListSemantic_getInstance();
        var tmp_7 = to(tmp_6, FinanceTableSemantic$default$lambda_2);
        var tmp_8 = ButtonSemantic_getInstance();
        var tmp_9 = to(tmp_8, FinanceTableSemantic$default$lambda_3);
        var tmp_10 = TextButtonSemantic_getInstance();
        return this.ed1(theme, VOID, VOID, VOID, VOID, VOID, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, mapOf_0([tmp_1, tmp_3, tmp_5, tmp_7, tmp_9, to(tmp_10, FinanceTableSemantic$default$lambda_4)]));
      }
      toString() {
        return 'FinanceTableSemantic';
      }
      hashCode() {
        return -2030368030;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FinanceTableSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'FinanceTableSemantic');
    FinanceTableSemanticClass = $;
  }
  return FinanceTableSemanticClass;
}
var FinanceTableSemantic_instance;
function FinanceTableSemantic_getInstance() {
  if (FinanceTableSemantic_instance === VOID)
    FinanceTableSemantic().bje();
  return FinanceTableSemantic_instance;
}
function renderContractorPaymentTable(_this__u8e3s4, payments) {
  var tmp = _this__u8e3s4.hbb(ListSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  var $this$col = view;
  trackWeights(($this$trackWeights) => {
    var tmp = $this$col.hbb(HeaderSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    var this_0 = $this$col;
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())(this_0.pc());
    var tmp0_elvis_lhs = this_0.cbb_1;
    var p = tmp0_elvis_lhs == null ? this_0 : tmp0_elvis_lhs;
    this_0.ebb(p, view);
    view.xbm(false);
    view.jbb(view.ibb(get_centered(view), $this$trackWeights.mg6(view, 1.7)), body(view, 'FROM'));
    view.jbb(view.ibb(get_centered(view), $this$trackWeights.mg6(view, 1.0)), centeredBody(view, 'SOURCE'));
    view.jbb(view.ibb(get_centered(view), $this$trackWeights.mg6(view, 1.1)), centeredBody(view, 'DATE'));
    view.jbb(view.ibb(get_centered(view), $this$trackWeights.mg6(view, 0.6)), centeredBody(view, 'STATUS'));
    view.jbb(view.ibb(get_centered(view), $this$trackWeights.mg6(view, 0.6)), centeredBody(view, 'AMOUNT'));
    var tmp_0 = view.ibb(get_centered(view), $this$trackWeights.mg6(view, 0.6));
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (Frame())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    var tmp_1 = view_0.ibb(get_centered(view_0), get_compact(view_0));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (RowOrCol())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.ebb(p_1, view_1);
    view_1.xbm(false);
    view_1.jbb(get_centered(view_1), body(view_1, 'FEE'));
    view_1.jbb(get_centered(view_1), smallBody(view_1, '(1%)'));
    view_0.fbb(p_1, view_1);
    view_0.jbb(tmp_1, view_1);
    view.fbb(p_0, view_0);
    view.jbb(tmp_0, view_0);
    view.jbb(view.ibb(get_centered(view), $this$trackWeights.mg6(view, 0.6)), centeredBody(view, 'TRANSFER'));
    var tmp_2 = $this$trackWeights.mg6(view, 0.3);
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    var tmp$ret$7 = view.hbb(ButtonSemantic_getInstance());
    var tmp_3 = view.ibb(tmp_2, tmp$ret$7);
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (Space())(view.pc());
    var tmp0_elvis_lhs_2 = view.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
    view.ebb(p_2, view_2);
    view.fbb(p_2, view_2);
    view.jbb(tmp_3, view_2);
    this_0.fbb(p, view);
    $this$col.jbb(tmp, view);
    var tmp_4 = $this$col.hbb(ListSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    var this_1 = $this$col;
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (RowOrCol())(this_1.pc());
    var tmp0_elvis_lhs_3 = this_1.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? this_1 : tmp0_elvis_lhs_3;
    this_1.ebb(p_3, view_3);
    view_3.xbm(true);
    var tmp_5 = lens(payments, renderContractorPaymentTable$lambda$lambda);
    var tmp_6 = renderContractorPaymentTable$lambda$lambda_0;
    forEachById(view_3, tmp_5, tmp_6, VOID, ($this$forEachById, indexed) => {
      var idx = lens(indexed, renderContractorPaymentTable$lambda$lambda$lambda_0);
      var log = lens(indexed, renderContractorPaymentTable$lambda$lambda$lambda_1);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (RowOrCol())($this$forEachById.pc());
      var tmp0_elvis_lhs = $this$forEachById.cbb_1;
      var p = tmp0_elvis_lhs == null ? $this$forEachById : tmp0_elvis_lhs;
      $this$forEachById.ebb(p, view);
      view.xbm(false);
      dynamicTheme(view, ($this$dynamicTheme) => ($this$dynamicTheme.baj(idx) % 2 | 0) === 0 ? CardSemantic_getInstance() : LightSection_getInstance());
      var tmp = view.ibb(get_centered(view), $this$trackWeights.ng6(view));
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_0 = new (TextView())(view.pc());
      var tmp0_elvis_lhs_0 = view.cbb_1;
      var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
      view.ebb(p_0, view_0);
      view_0.jba(view_0.ob6_1.ybe(BodySemantic_getInstance()));
      var tmp_0 = KMutableProperty0();
      var tmp_1 = TextView$_get_content_$ref_4pzcwl(view_0);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb(view_0));
      reactiveScope(view_0, ($this$reactiveScope) => {
        var id = $this$reactiveScope.baj(log).r7k_1;
        var tmp;
        if (id == null) {
          tmp = 'Project Completed';
        } else {
          // Inline function 'kotlin.collections.find' call
          var tmp0 = $this$reactiveScope.baj(payments).zjd_1;
          var tmp$ret$16;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (element.g6k_1.equals(id)) {
                tmp$ret$16 = element;
                break $l$block;
              }
            }
            tmp$ret$16 = null;
          }
          var tmp0_safe_receiver = tmp$ret$16;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l6k_1;
          tmp = tmp1_elvis_lhs == null ? '...' : tmp1_elvis_lhs;
        }
        var tmp$ret$18 = tmp;
        this_0.set(tmp$ret$18);
        return Unit_instance;
      });
      view.fbb(p_0, view_0);
      view.jbb(tmp, view_0);
      var tmp_2 = view.ibb(get_centered(view), $this$trackWeights.ng6(view));
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_1 = new (TextView())(view.pc());
      var tmp0_elvis_lhs_1 = view.cbb_1;
      var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
      view.ebb(p_1, view_1);
      view_1.jba(view_1.ob6_1.ybe(BodySemantic_getInstance()));
      view_1.bbs(Align_Center_getInstance());
      var tmp_3 = KMutableProperty0();
      var tmp_4 = TextView$_get_content_$ref_4pzcwl_0(view_1);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_1 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb_0(view_1));
      reactiveScope(view_1, ($this$reactiveScope) => {
        var log_0 = $this$reactiveScope.baj(log);
        var tmp$ret$25 = !(log_0.s7k_1 == null) ? 'Draw Payment' : !(log_0.r7k_1 == null) ? 'Work Item Approval' : 'Retention Release';
        this_1.set(tmp$ret$25);
        return Unit_instance;
      });
      view.fbb(p_1, view_1);
      view.jbb(tmp_2, view_1);
      var tmp_5 = view.ibb(get_centered(view), $this$trackWeights.ng6(view));
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_2 = new (TextView())(view.pc());
      var tmp0_elvis_lhs_2 = view.cbb_1;
      var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
      view.ebb(p_2, view_2);
      view_2.jba(view_2.ob6_1.ybe(BodySemantic_getInstance()));
      view_2.bbs(Align_Center_getInstance());
      var tmp_6 = KMutableProperty0();
      var tmp_7 = TextView$_get_content_$ref_4pzcwl_1(view_2);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_2 = getPropertyCallableRef('content', 0, tmp_6, tmp_7, TextView$_set_content_$ref_pketfb_1(view_2));
      reactiveScope(view_2, ($this$reactiveScope) => {
        var tmp$ret$32 = renderToString($this$reactiveScope.baj(log).h7l_1, RenderSize_Numerical_getInstance());
        this_2.set(tmp$ret$32);
        return Unit_instance;
      });
      view.fbb(p_2, view_2);
      view.jbb(tmp_5, view_2);
      var tmp_8 = view.ibb(get_centered(view), $this$trackWeights.ng6(view));
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_3 = new (TextView())(view.pc());
      var tmp0_elvis_lhs_3 = view.cbb_1;
      var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
      view.ebb(p_3, view_3);
      view_3.jba(view_3.ob6_1.ybe(BodySemantic_getInstance()));
      view_3.bbs(Align_Center_getInstance());
      dynamicTheme(view_3, ($this$dynamicTheme) => DisplayableStateSemantic().mgt($this$dynamicTheme.baj(log).y7k_1));
      var tmp_9 = KMutableProperty0();
      var tmp_10 = TextView$_get_content_$ref_4pzcwl_2(view_3);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_3 = getPropertyCallableRef('content', 0, tmp_9, tmp_10, TextView$_set_content_$ref_pketfb_2(view_3));
      reactiveScope(view_3, ($this$reactiveScope) => {
        var tmp$ret$39 = $this$reactiveScope.baj(log).y7k_1.r9c_1;
        this_3.set(tmp$ret$39);
        return Unit_instance;
      });
      view.fbb(p_3, view_3);
      view.jbb(tmp_8, view_3);
      var tmp_11 = view.ibb(get_centered(view), $this$trackWeights.ng6(view));
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_4 = new (TextView())(view.pc());
      var tmp0_elvis_lhs_4 = view.cbb_1;
      var p_4 = tmp0_elvis_lhs_4 == null ? view : tmp0_elvis_lhs_4;
      view.ebb(p_4, view_4);
      view_4.jba(view_4.ob6_1.ybe(BodySemantic_getInstance()));
      view_4.bbs(Align_Center_getInstance());
      var tmp_12 = KMutableProperty0();
      var tmp_13 = TextView$_get_content_$ref_4pzcwl_3(view_4);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_4 = getPropertyCallableRef('content', 0, tmp_12, tmp_13, TextView$_set_content_$ref_pketfb_3(view_4));
      reactiveScope(view_4, ($this$reactiveScope) => {
        var tmp$ret$46 = MonetaryValue__toStringAbsolute_impl_uovmiu($this$reactiveScope.baj(log).u7k_1);
        this_4.set(tmp$ret$46);
        return Unit_instance;
      });
      view.fbb(p_4, view_4);
      view.jbb(tmp_11, view_4);
      var tmp_14 = view.ibb(get_centered(view), $this$trackWeights.ng6(view));
      // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_5 = new (Frame())(view.pc());
      var tmp0_elvis_lhs_5 = view.cbb_1;
      var p_5 = tmp0_elvis_lhs_5 == null ? view : tmp0_elvis_lhs_5;
      view.ebb(p_5, view_5);
      var tmp_15 = view_5.ibb(get_centered(view_5), get_compact(view_5));
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_6 = new (RowOrCol())(view_5.pc());
      var tmp0_elvis_lhs_6 = view_5.cbb_1;
      var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
      view_5.ebb(p_6, view_6);
      view_6.xbm(false);
      var tmp_16 = get_centered(view_6);
      view_6.jbb(view_6.ibb(tmp_16, shownWhen(view_6, VOID, ($this$shownWhen) => {
        var log_0 = $this$shownWhen.baj(log);
        var tmp0_safe_receiver = log_0.v7k_1;
        var tmp;
        var tmp_0 = tmp0_safe_receiver;
        if ((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null) {
          tmp = null;
        } else {
          tmp = _MonetaryValue___get_absoluteValue__impl__hjldkw(tmp0_safe_receiver);
        }
        var tmp1_elvis_lhs = tmp;
        var tmp_1;
        var tmp_2 = tmp1_elvis_lhs;
        if ((tmp_2 == null ? null : new (MonetaryValue())(tmp_2)) == null) {
          tmp_1 = Companion_instance.o62(0);
        } else {
          tmp_1 = tmp1_elvis_lhs;
        }
        return MonetaryValue__compareTo_impl_w7ul1r(tmp_1, MonetaryValue__times_impl_hlr6p7(_MonetaryValue___get_absoluteValue__impl__hjldkw(log_0.u7k_1), 0.01)) > 0;
      })), infoBubble(view_6, 'This fee include corrections for rounding errors in previous fees.'));
      var tmp_17 = get_centered(view_6);
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_7 = new (TextView())(view_6.pc());
      var tmp0_elvis_lhs_7 = view_6.cbb_1;
      var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
      view_6.ebb(p_7, view_7);
      view_7.jba(view_7.ob6_1.ybe(BodySemantic_getInstance()));
      var tmp_18 = KMutableProperty0();
      var tmp_19 = TextView$_get_content_$ref_4pzcwl_4(view_7);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_5 = getPropertyCallableRef('content', 0, tmp_18, tmp_19, TextView$_set_content_$ref_pketfb_4(view_7));
      reactiveScope(view_7, ($this$reactiveScope) => {
        var tmp0_elvis_lhs = $this$reactiveScope.baj(log).v7k_1;
        var tmp;
        var tmp_0 = tmp0_elvis_lhs;
        if ((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null) {
          tmp = Companion_instance.o62(0);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var tmp$ret$53 = MonetaryValue__toStringAbsolute_impl_uovmiu(tmp);
        this_5.set(tmp$ret$53);
        return Unit_instance;
      });
      view_6.fbb(p_7, view_7);
      view_6.jbb(tmp_17, view_7);
      view_5.fbb(p_6, view_6);
      view_5.jbb(tmp_15, view_6);
      view.fbb(p_5, view_5);
      view.jbb(tmp_14, view_5);
      var tmp_20 = view.ibb(get_centered(view), $this$trackWeights.ng6(view));
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_8 = new (TextView())(view.pc());
      var tmp0_elvis_lhs_8 = view.cbb_1;
      var p_8 = tmp0_elvis_lhs_8 == null ? view : tmp0_elvis_lhs_8;
      view.ebb(p_8, view_8);
      view_8.jba(view_8.ob6_1.ybe(BodySemantic_getInstance()));
      view_8.bbs(Align_Center_getInstance());
      var tmp_21 = KMutableProperty0();
      var tmp_22 = TextView$_get_content_$ref_4pzcwl_5(view_8);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_6 = getPropertyCallableRef('content', 0, tmp_21, tmp_22, TextView$_set_content_$ref_pketfb_5(view_8));
      reactiveScope(view_8, ($this$reactiveScope) => {
        // Inline function 'kotlin.let' call
        var it = $this$reactiveScope.baj(log);
        var tmp = _MonetaryValue___get_absoluteValue__impl__hjldkw(it.u7k_1);
        var tmp0_elvis_lhs = it.v7k_1;
        var tmp_0;
        var tmp_1 = tmp0_elvis_lhs;
        if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
          tmp_0 = Companion_instance.o62(0);
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var tmp$ret$68 = MonetaryValue__minus_impl_jw9qyp(tmp, tmp_0);
        var tmp$ret$69 = MonetaryValue__toString_impl_xslc77(tmp$ret$68);
        this_6.set(tmp$ret$69);
        return Unit_instance;
      });
      view.fbb(p_8, view_8);
      view.jbb(tmp_20, view_8);
      var tmp_23 = view.ibb(view.ibb(get_centered(view), $this$trackWeights.ng6(view)), get_textButton(view));
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_9 = new (Button())(view.pc());
      var tmp0_elvis_lhs_9 = view.cbb_1;
      var p_9 = tmp0_elvis_lhs_9 == null ? view : tmp0_elvis_lhs_9;
      view.ebb(p_9, view_9);
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_10 = new (TextView())(view_9.pc());
      var tmp0_elvis_lhs_10 = view_9.cbb_1;
      var p_10 = tmp0_elvis_lhs_10 == null ? view_9 : tmp0_elvis_lhs_10;
      view_9.ebb(p_10, view_10);
      view_10.jba(view_10.ob6_1.ybe(BodySemantic_getInstance()));
      view_10.bbs(Align_Center_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
      var tmp_24 = view_10.tb5_1;
      var tmp_25;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength('View') === 0) {
        tmp_25 = '\xA0';
      } else {
        tmp_25 = 'View';
      }
      tmp_24.fbu(tmp_25);
      view_9.fbb(p_10, view_10);
      onClick(view_9, 'View Payment Source', VOID, renderContractorPaymentTable$lambda$lambda$slambda_0(log, view_9));
      view.fbb(p_9, view_9);
      view.jbb(tmp_23, view_9);
      $this$forEachById.fbb(p, view);
      return view;
    });
    this_1.fbb(p_3, view_3);
    $this$col.jbb(tmp_4, view_3);
    return Unit_instance;
  });
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.cje_1 = function_0;
      }
      wi(a, b) {
        return this.cje_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.cje_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function renderContractorPaymentTable$lambda$lambda(p) {
  // Inline function 'kotlin.collections.sortedBy' call
  var this_0 = p.yjd_1;
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp = renderContractorPaymentTable$lambda$lambda$lambda;
  var tmp$ret$0 = new (sam$kotlin_Comparator$0())(tmp);
  var tmp$ret$1 = sortedWith(this_0, tmp$ret$0);
  return toList(withIndex(tmp$ret$1));
}
function renderContractorPaymentTable$lambda$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.h7l_1;
  var tmp$ret$1 = b.h7l_1;
  return compareValues(tmp, tmp$ret$1);
}
function renderContractorPaymentTable$lambda$lambda_0(it) {
  return it.ml_1.p7k_1;
}
function renderContractorPaymentTable$lambda$lambda$lambda_0(it) {
  return it.ll_1;
}
function renderContractorPaymentTable$lambda$lambda$lambda_1(it) {
  return it.ml_1;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_4(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_4(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_5(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_5(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.dje_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var log = tmp;
  var tmp0_safe_receiver = log.s7k_1;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    JumpTo_getInstance().tg3_1.zg4(tmp0_safe_receiver);
    tmp_0 = Unit_instance;
  }
  if (tmp_0 == null) {
    var tmp2_safe_receiver = log.r7k_1;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      JumpTo_getInstance().rg3_1.zg4(tmp2_safe_receiver);
    }
  }
  var tmp_1 = lastOrNull(get_pageNavigator($this.eje_1).gbn_1.f2());
  if (!(tmp_1 instanceof ContractorProject())) {
    get_pageNavigator($this.eje_1).dbw(new (ContractorProject())(log.q7k_1));
  }
  return Unit_instance;
}
var renderContractorPaymentTable$lambda$lambda$slambdaClass;
function renderContractorPaymentTable$lambda$lambda$slambda() {
  if (renderContractorPaymentTable$lambda$lambda$slambdaClass === VOID) {
    class $ {
      constructor($log, $$this$button) {
        this.dje_1 = $log;
        this.eje_1 = $$this$button;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderContractorPaymentTable$lambda$lambda$slambdaClass = $;
  }
  return renderContractorPaymentTable$lambda$lambda$slambdaClass;
}
function renderContractorPaymentTable$lambda$lambda$slambda_0($log, $$this$button) {
  var i = new (renderContractorPaymentTable$lambda$lambda$slambda())($log, $$this$button);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
//region block: exports
export {
  ProjectContractorPayments as ProjectContractorPayments2a1bksdtdzr6w,
  renderContractorPaymentTable as renderContractorPaymentTable2wgebbq97b8wg,
  FinanceTableSemantic_getInstance as FinanceTableSemantic_getInstance2sirlds87craf,
};
//endregion

//# sourceMappingURL=AvailableFunds.mjs.map
